<template>
  <el-dialog
    title="配置表格"
    width="800px"
    :visible.sync="dialogVisible"
    :before-close="close"
    :close-on-click-modal="false"
    append-to-body
    @open="open"
  >
    <div v-if="type === 1" class="createTable">
      <div class="num">
        {{ rowNum }}行 x {{ colNum }}列
      </div>
      <div class="tableWrap">
        <div class="table">
          <div v-for="item in 10" :key="item" class="tr">
            <div
              v-for="tdItem in 10"
              :key="tdItem"
              class="td"
              @click="tdTap(item, tdItem)"
            ></div>
          </div>
          <div
            class="block"
            :style="`width:${blockWidth}px;height:${blockHeight}px`"
          ></div>
        </div>
      </div>
      <div class="desc">
        选择列行数生成表格
      </div>
    </div>
    <div v-if="type === 2" class="dataTableBox">
      <div class="formWrapping">
        <div class="radio">
          <el-radio
            v-model="tableTextType"
            label="1"
            @change="tableTextTypeChange"
          >自定义表格内容</el-radio>
          <el-radio
            v-model="tableTextType"
            label="2"
            @change="tableTextTypeChange"
          >展示项目数据</el-radio>
          <div class="tips">
            切换数据类型或项目数据，将会清空表格里的内容
          </div>
        </div>
        <div class="select">
          <el-select
            v-model="dataType"
            :clearable="false"
            :disabled="tableTextType === '1'"
            @change="dataTypeChange"
          >
            <el-option
              v-for="item in dataTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
      <div
        class="dataTableWrapper"
        :class="{ isTrResizing, isTdResizing }"
        @mousedown="trMousedown"
        @mousemove="trMousemove"
        @mouseup="trMouseup"
      >
        <div class="dataTableWrapperBox">
          <div class="dataTableWrapping">
            <div class="dataTable">
              <div
                v-for="(item, index) in dataList"
                :key="index"
                class="tr"
                :style="`height:${item.trHeight}px`"
              >
                <div
                  v-for="(tdItem, tdIndex) in item.children"
                  :key="tdIndex"
                  class="td"
                  :style="`width:${tdItem.tdWidth}px`"
                >
                  <template v-if="tableTextType === '1'">
                    <el-input
                      v-model="tdItem.value"
                      placeholder="点击输入内容"
                    />
                  </template>
                  <template v-else>
                    <el-select
                      v-model="tdItem.value"
                      placeholder="选择表格内容"
                      :loading="loading"
                    >
                      <el-option
                        v-for="dataItem in tableList"
                        :key="dataItem.valule"
                        :label="dataItem.realValue"
                        :value="dataItem"
                      >
                        {{ dataItem.realValue }}
                      </el-option>
                    </el-select>
                  </template>
                  <div
                    class="tdLine"
                    :data-index="index"
                    :data-td-index="tdIndex"
                  ></div>
                </div>
                <div class="trLine" :data-index="index"></div>
              </div>
            </div>
          </div>
          <div class="colOperation">
            <i class="el-icon-remove-outline" @click="colRemove"></i>
            <i class="el-icon-circle-plus-outline" @click="colAdd"></i>
          </div>
          <div class="rowOperation">
            <i class="el-icon-circle-plus-outline" @click="rowAdd"></i>
            <i class="el-icon-remove-outline" @click="rowRemove"></i>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="formOnSubmit('form')"
      >提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { projectInfoList, siteCountList, realTimeCountList } from './data'
import {
  companyListByProject,
  teamPersonCount,
  workTypePersonCount
} from '@/api/manage'
import { siteStatisticsPersonCount } from '@/api/dashboard'
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    refreshReportLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    companyItem: {
      type: Object,
      default: () => {}
    },
    agreementList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      type: 1,
      tableTextType: '1',
      dataType: '',
      dataTypeList: [
        {
          label: '项目信息',
          value: '1'
        },
        {
          label: '参建单位',
          value: '2'
        },
        {
          label: '现场人数',
          value: '3'
        },
        {
          label: '实时人数',
          value: '4'
        },
        {
          label: '班组人数',
          value: '5'
        },
        {
          label: '工种人数',
          value: '6'
        }
      ],
      dataList: [
        {
          children: [
            {
              value: ''
            },
            {
              value: ''
            },
            {
              value: ''
            }
          ]
        },
        {
          children: [
            {
              value: ''
            },
            {
              value: ''
            },
            {
              value: ''
            }
          ]
        }
      ],
      colNum: 3,
      rowNum: 2,
      colAddDisable: false,
      colRemoveDisable: false,
      rowAddDisable: false,
      rowRemoveDisable: false,
      tableList: [],
      loading: false,
      isTrResizing: false,
      startY: 0,
      trIndex: 0,
      startHeight: 40,
      isTdResizing: false,
      startX: 0,
      tdIndex: 0,
      startWidth: 200,
      blockWidth: 60,
      blockHeight: 40,
      isUpdate: false
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },

  methods: {
    close() {
      this.$emit('close')
    },
    open() {
      if (!this.isUpdate) {
        this.type = 1
        this.tdTap(2, 3)
      }
      this.isUpdate = false
    },
    tdTap(row, col) {
      this.rowNum = row
      this.colNum = col
      const list = []
      for (let index = 0; index < row; index++) {
        const item = { children: [], trHeight: 40 }
        for (let j = 0; j < col; j++) {
          item.children.push({ value: '', tdWidth: 200 })
        }
        list.push(item)
      }
      this.blockWidth = col * 20
      this.blockHeight = row * 20
      this.dataList = list
      //
    },
    tableTextTypeChange() {
      this.dataList.forEach((element) => {
        element.children.forEach((item) => {
          item.value = ''
        })
      })
      if (this.tableTextType === '2') {
        if (!this.dataType) {
          this.dataType = '1'
        }
        projectInfoList[1].realValue = this.projectItem.projectStatusName
        projectInfoList[3].realValue = this.projectItem.projectTypeName
        projectInfoList[5].realValue = this.projectItem.managerName
        projectInfoList[7].realValue = this.projectItem.managerPhone
        projectInfoList[9].realValue =
          this.projectItem.startDate && this.projectItem.startDate.split(' ')[0]
        projectInfoList[11].realValue =
          this.projectItem.planEndDate &&
          this.projectItem.planEndDate.split(' ')[0]
        projectInfoList[13].realValue = this.projectItem.address
        this.tableList = projectInfoList
      }
    },
    dataTypeChange(e) {
      if (e === '1') {
        projectInfoList[1].realValue = this.projectItem.projectStatusName
        projectInfoList[3].realValue = this.projectItem.projectTypeName
        projectInfoList[5].realValue = this.projectItem.managerName
        projectInfoList[7].realValue = this.projectItem.managerPhone
        projectInfoList[9].realValue =
          this.projectItem.startDate && this.projectItem.startDate.split(' ')[0]
        projectInfoList[11].realValue =
          this.projectItem.planEndDate &&
          this.projectItem.planEndDate.split(' ')[0]
        projectInfoList[13].realValue = this.projectItem.address
        this.tableList = projectInfoList
      } else if (e === '2') {
        this.getCompanyData()
      } else if (e === '3') {
        this.getSiteStatisticsPersonCount(e)
      } else if (e === '4') {
        this.getSiteStatisticsPersonCount(e)
      } else if (e === '5') {
        this.getTeamData()
      } else {
        this.getWorkPersonData()
      }
    },
    getSiteStatisticsPersonCount(e) {
      this.loading = true
      siteStatisticsPersonCount({ projectId: this.projectItem.projectId })
        .then((res) => {
          if (e === '3') {
            siteCountList[1].realValue = res.data.onJobCount + ''
            siteCountList[3].realValue = res.data.inCount + ''
            siteCountList[5].realValue = res.data.outCount + ''
            siteCountList[7].realValue = res.data.entryPersonAmount + ''
            siteCountList[9].realValue = res.data.workerCount + ''
            siteCountList[11].realValue = res.data.managerCount + ''
            siteCountList[13].realValue = res.data.attendanceRate + '%'
            console.log('siteCountList', siteCountList)
            this.tableList = siteCountList
          }
          if (e === '4') {
            realTimeCountList[1].realValue = res.data.entryPersonAmount + ''
            realTimeCountList[3].realValue = res.data.entryManagerCount + ''
            realTimeCountList[5].realValue = res.data.entryWorkerCount + ''
            this.tableList = realTimeCountList
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCompanyData() {
      this.loading = true
      companyListByProject({ projectId: this.projectItem.projectId })
        .then((res) => {
          const list = []
          res.data.records.forEach((item) => {
            list.push({
              label: item.companyTypeName,
              value: item.companyTypeName,
              realValue: item.companyTypeName
            })
            list.push({
              label: `{${item.companyName}}`,
              value: `#company_${item.companyId}_name#`,
              realValue: item.companyName
            })
          })
          this.tableList = list
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTeamData() {
      this.loading = true
      teamPersonCount({
        projectId: this.projectItem.projectId
      })
        .then((res) => {
          const list = []
          res.data.forEach((item) => {
            list.push({
              label: item.teamName,
              value: `#team_${item.teamId}_name#`,
              realValue: item.teamName
            })
            list.push({
              label: `{${item.teamName}内容}`,
              value: `#team_${item.teamId}_personCount#`,
              realValue: item.personCount + ''
            })
          })
          this.tableList = list
        })
        .finally(() => {
          this.loading = false
        })
    },
    getWorkPersonData() {
      this.loading = true
      workTypePersonCount({
        projectId: this.projectItem.projectId
      })
        .then((res) => {
          const list = []
          res.data.forEach((item) => {
            if (item.workerTypeName) {
              list.push({
                label: item.workerTypeName,
                value: `#dic_${item.workerTypeId}_name#`,
                realValue: item.workerTypeName
              })
              list.push({
                label: `{${item.workerTypeName}内容}`,
                value: `#workerType_${item.workerTypeId}_personCount#`,
                realValue: item.personCount + ''
              })
            }
          })
          this.tableList = list
        })
        .finally(() => {
          this.loading = false
        })
    },
    async colAdd() {
      if (this.colAddDisable || this.colNum >= 10) {
        return
      }
      this.colAddDisable = true
      await new Promise((resolve, reject) => {
        this.dataList.forEach((item) => {
          const tdItem = {}
          this.$set(tdItem, 'value', '')
          this.$set(tdItem, 'tdWidth', 200)
          item.children.push(tdItem)
        })
        this.colNum++
        resolve()
      })
      this.colAddDisable = false
    },
    async colRemove() {
      if (this.colRemoveDisable || this.colNum === 0) {
        return
      }
      this.colRemoveDisable = true
      await new Promise((resolve, reject) => {
        this.dataList.forEach((item) => {
          item.children.splice(item.children.length - 1, 1)
        })
        this.colNum--
        resolve()
      })
      this.colRemoveDisable = false
    },
    async rowAdd() {
      if (this.rowAddDisable || this.rowNum >= 10) {
        return
      }
      this.rowAddDisable = true
      await new Promise((resolve, reject) => {
        const children = []
        for (let index = 0; index < this.colNum; index++) {
          const item = {}
          this.$set(item, 'value', '')
          this.$set(item, 'tdWidth', this.dataList[0].children[index].tdWidth)
          children.push(item)
        }
        this.rowNum++
        this.dataList.push({ children, trHeight: 40 })
        console.log('dataList', this.dataList)
        resolve()
      })
      this.rowAddDisable = false
    },
    async rowRemove() {
      if (this.rowRemoveDisable || this.rowNum === 0) {
        return
      }
      this.rowRemoveDisable = true
      await new Promise((resolve, reject) => {
        this.dataList.splice(this.dataList.length - 1, 1)
        this.rowNum--
        resolve()
      })
      this.rowRemoveDisable = false
    },

    formOnSubmit(formName) {
      if (this.type === 1) {
        this.type = 2
      } else {
        const isEmpty = this.dataList.some((element) => {
          return element.children.some((item) => !item.value)
        })
        if (isEmpty) {
          this.$message.warning('表格项不能为空！')
          return
        }
        const list = _.cloneDeep(this.dataList)
        this.$emit('formOnSubmit', {
          dataList: list,
          tableTextType: this.tableTextType,
          dataType: this.dataType,
          colNum: this.colNum,
          rowNum: this.rowNum
        })
      }
    },
    setData(data) {
      this.isUpdate = true
      this.type = 2
      this.dataTypeChange(data.dataType)
      this.dataList = data.dataList
      this.tableTextType = data.tableTextType
      this.dataType = data.dataType
      this.colNum = data.colNum
      this.rowNum = data.rowNum
    },
    trMousedown(e) {
      if (e.target.className === 'trLine') {
        this.trIndex = parseInt(e.target.dataset.index)
        this.isTrResizing = true
        this.startY = e.clientY
        this.startHeight = this.dataList[this.trIndex].trHeight
      }
      if (e.target.className === 'tdLine') {
        this.trIndex = parseInt(e.target.dataset.index)
        this.tdIndex = parseInt(e.target.dataset.tdIndex)
        this.isTdResizing = true
        this.startX = e.clientX
        this.startWidth =
          this.dataList[this.trIndex].children[this.tdIndex].tdWidth
      }
    },
    trMousemove(e) {
      if (this.isTrResizing) {
        const height = e.clientY - this.startY

        const endHeight = this.startHeight + height
        if (endHeight > 32 && endHeight < 200) {
          this.dataList[this.trIndex].trHeight = endHeight
        }
      }
      if (this.isTdResizing) {
        const width = e.clientX - this.startX
        const endWidth = this.startWidth + width
        if (endWidth > 10 && endWidth < 600) {
          this.dataList.forEach((element) => {
            element.children[this.tdIndex].tdWidth = endWidth
          })
        }
      }
    },
    trMouseup(e) {
      this.isTrResizing = false
      this.isTdResizing = false
    }
  }
}
</script>

<style scoped lang="scss">
.createTable {
  .num {
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  .tableWrap {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    .table {
      border-top: 1px solid #797979;
      border-left: 1px solid #797979;
      cursor: pointer;
      position: relative;
      .tr {
        height: 20px;
        display: flex;
        position: relative;
        z-index: 1;
        .td {
          width: 20px;
          height: 100%;
          border-right: 1px solid #797979;
          border-bottom: 1px solid #797979;
        }
      }
      .block {
        position: absolute;
        width: 60px;
        height: 40px;
        background: #409eff;
        top: 0;
        left: 0;
        z-index: 0;
      }
    }
  }
  .desc {
    text-align: center;
    font-size: 14px;
    color: #333333;
    margin-top: 10px;
  }
}
.dataTableBox {
  .formWrapping {
    display: flex;
    padding-left: 110px;
    .radio {
      .tips {
        font-size: 10px;
        color: #ff0000;
        margin-top: 6px;
      }
    }
  }
  .dataTableWrapper {
    padding-top: 10px;
    min-height: 400px;
    .dataTableWrapperBox {
      width: 602px;
      margin: 0 auto;
      position: relative;
    }
    .dataTableWrapping {
      width: 602px;
      position: relative;
      overflow-x: auto;
      display: flex;
      border-left: 1px solid #797979;
      border-right: 1px solid #797979;
      border-top: 1px solid #797979;
      border-bottom: 1px solid #797979;
    }
    .dataTable {
      // border-right: 1px solid #797979;

      .tr {
        height: 40px;
        display: flex;
        position: relative;
        .td {
          width: 200px;
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0 10px;
          flex-shrink: 0;
          position: relative;
          &:last-child {
            // border-right: none;
          }
          .tdLine {
            position: absolute;
            height: 100%;
            width: 3px;
            right: 0;
            top: 0;
            cursor: w-resize;
            border-right: 1px solid #797979;
          }
        }
        .trLine {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 3px;
          border-bottom: 1px solid #797979;
          cursor: s-resize;
        }
      }
    }
    .colOperation {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(50%, -100%);
      font-size: 18px;
      i {
        margin-left: 2px;
        cursor: pointer;
      }
    }
    .rowOperation {
      position: absolute;
      left: 0;
      bottom: 0;
      transform: translate(-100%);
      font-size: 18px;
      i {
        margin-left: 2px;
        cursor: pointer;
      }
    }
  }
  .isTrResizing {
    cursor: s-resize;
  }
  .isTdResizing {
    cursor: e-resize;
  }
}
</style>
